<template>
  <!-- <div class="" style="position:fixed">
     -->
  <div class="" style="position:fixed">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF"><HeaderConsumer/></b-col>
            <b-col cols="12 headerM"><HeaderConsumerMobile/></b-col>
          </b-row>

        <br>
        <form id="form-vendor-code">
              <b-row style="width:100vw">
                      <b-col col cols="12" sm="3" md="3" lg="3" class="sideNav">
                          <AdminPrepaidSideNav />
                      </b-col>
                      <b-col col cols="12" sm="12" md="9" lg="9" style="height:78vh; overflow-y:scroll " class="shadow">
                        <b-row>
                          <b-col col cols="12" sm="12" md="12" lg="12">
                           <h1 class="heading">Prepaid Voucher Code Generation</h1>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                            <h6>Transaction id: </h6>
                          </b-col>
                          <b-col col cols="12" sm="9" md="9" lg="9">
                              <input id="" v-model="transId" type="text" class="validate" name="" placeholder="Enter transaction id" style="width: 100%;">
                          </b-col>
                        </b-row>
                        <br>
                        <b-row>
                          <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                            <h6>Transaction Reference No. : </h6>
                          </b-col>
                          <b-col col cols="12" sm="3" md="3" lg="3">
                              <input id="" v-model="transRefNo" type="text" class="validate" name="" placeholder="Enter transaction ref. no">
                            </b-col>

                          <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                            <h6>Transaction Date: </h6>
                          </b-col>
                          <b-col col cols="12" sm="3" md="3" lg="3">
                            <input id="" v-model="transDate" type="text" class="validate" name="" placeholder="Enter transaction date">
                            </b-col>
                        </b-row><br>
                        <b-row>
                          <b-col col cols="12" sm="3" md="3" lg="3" class="text-left">
                            <h6>Bank Reference No. :  </h6>
                          </b-col>
                          <b-col col cols="12" sm="3" md="3" lg="3">
                            <input id="" v-model="bankRefNo" type="text" class="validate" name="" placeholder="Enter Bank ref. no">
                            </b-col>
                            <b-col col cols="12" sm="12" md="3" lg="3" class="text-left">
                              <h6>Bank ID: </h6>
                            </b-col>
                            <b-col col cols="12" sm="3" md="3" lg="3" >
                              <input id="" v-model="bankId" type="text" class="validate" name="" placeholder="Enter bank id">
                            </b-col>
                        </b-row>
                        <br>
                        <b-row>
                          <b-col col cols="12" sm="12" md="3" lg="3" class="text-left">
                            <h6>Authetication Status: </h6>
                          </b-col>
                          <b-col col cols="12" sm="3" md="3" lg="3" >
                            <span v-model="authStat">0300</span>
                          </b-col>
                        </b-row>
                        <br>
                        <b-row>
                          <b-col col cols="6" sm="6" md="2" lg="2" offset-md="4" offset-lg="4" class="text-center">
                            <b-button variant="info" @click="generateVoucher($event)">Generate</b-button>
                          </b-col>
                          <b-col col cols="6" sm="6" md="2" lg="2" class="text-center">
                            <b-button variant="outline-danger">CANCEL</b-button>
                          </b-col>
                        </b-row>

                  </b-col>
            </b-row>
          </form>
    </b-container>
    </b-overlay>
   <br><br>
  </div>
<!-- </div> -->
</template>

<script>
import AdminPrepaidSideNav from '@/components/AdminPrepaidSideNav.vue'
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import axios from 'axios'


export default {
  name: 'Admin',
  components: {
    'AdminPrepaidSideNav' : AdminPrepaidSideNav,
    'HeaderConsumer' : HeaderConsumer,
    'HeaderConsumerMobile' : HeaderConsumerMobile

  },
  data(){
    return{
      transId: '',
      transRefNo: '',
      bankRefNo: '',
      bankId: '',
      transDate: '',
      authStat: '',
      show:false
    }
  },
  methods:
  {
    generateVoucher(event){
      event.stopPropagation()
      event.preventDefault()
      var transId = this.transId;
      var transRefNo = this.transRefNo;
      var bankRefNo = this.bankRefNo;
      var bankId = this.bankId;
      var transDate = this.transDate;

      if(transId == ""){
        this.$bvToast.toast('Transaction Id can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      if(transRefNo == ""){
        this.$bvToast.toast('Transaction Reference number can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      if(bankRefNo == ""){
        this.$bvToast.toast('Bank Reference number can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      if(bankId == ""){
        this.$bvToast.toast('Bank ID can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }
      if(transDate == ""){
        this.$bvToast.toast('Transaction Date can not be empty !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return
      }

      var FormData = require('form-data');
      var formData = new FormData();
      formData.append('transactionId', transId);
      formData.append('txnRefNo', transRefNo);
      formData.append('bankRefNo', bankRefNo);
      formData.append('bankId', bankId);
      formData.append('transDate', transDate);
      formData.append('authStat', "0300");

      for (var value of formData.values()) {
         console.log(value);
      }

      //  var parent = this;
      //  parent.show=true;
    //   axios.post(urlCommon + "/api/admin/", formData).then(function(response) {
    // //    parent.show=false;
    //     console.log (response.data )

      //
      // });
    }
  },
  mounted()
  {
    var userId = localStorage.getItem("userId");
    var userName = localStorage.getItem("userName");
      // {
      //   this.$router.push({ path: '/' })
      //   return;
      // }

      document.getElementById("consName").innerHTML = userName ;
      document.getElementById("consNameMb").innerHTML = userName ;

      var btn=document.getElementById("bprepaidVoucher");
      document.querySelector(".btn-color-active").classList.remove("btn-color-active");
      btn.classList.add("btn-color-active");
  }

}


</script>

<style scoped="true">
body{
  overflow-y:hidden !important;
}
.menuCol
{
 display:block;
}
.menuItem
{
  border-radius: 50%;
  height:10rem;
  width:10rem;
  margin-top:1rem;
}
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;
  color: #6a1b9a ;
}

li{
  padding:0;
}

    body{
      overflow-y:hidden;
    }
.shadow{}
  .headerF{
  display: block;
}
.headerM{
  display: none;
}
.sideNav{
  height:75vh;
  overflow-y:auto;
}
.dropdownmenu{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
  @media (max-width: 576px) {
    .sideNav{
      /* height:50vh;
      overflow-y:hidden; */
      display: none
    }
    .dropdownmenu{
      display: block;
    }
  }
</style>
